import { Translator } from '../../types/ApiResponseTypes'
import { CustomerResponse, isCustomerAddressResponse, isCustomerResponse } from '@/types/customer/CustomerResponseType'
import { Customer } from '@/types/customer/CustomerType'

class CustomerResponseTranslator implements Translator<Customer> {
  convert(response: any): Customer | Customer[] {
    if (isCustomerResponse(response)) {
      return this.convertToCustomerModel(response)
    }
    return []
  }

  convertToCustomerModel(response: CustomerResponse): Customer {
    if (!isCustomerAddressResponse(response.address[0])) {
      return {} as Customer
    }

    return {
      customerId: response.id,
      billingAddress: {
        id: response.id.toString(),
        companyName: response.name ?? '',
        street: response.address[0].street ?? '',
        city: response.address[0].city ?? '',
        number: response.address[0].streetNumber ?? '',
        bus: response.address[0].bus ?? '',
        postalCode: response.address[0].zipCode ?? '',
        country: response.address[0].country ?? '',
        countryId: response.address[0].countryId ?? '',
      },
      companyInfo: {
        name: response.name ?? '',
        vat: response.vat ?? '',
      },
      invoiceMethod: {
        email: response.invoiceByPost == '1' ? false : true,
        post: response.invoiceByPost == '1' ? true : false,
        peppol: response.invoiceByPeppol === 1,
        peppolId: response.peppolId ?? '',
        emailAddress: response.emailAddressInvoice,
      },
    }
  }
}
export default new CustomerResponseTranslator()
